( function ( ) {
	'use strict';
	/* eslint no-else-return:0 */
	/* @ngInject */
	function obsPoolModal () {
		var directive = {
			'restrict'     : 'E',
			'templateUrl'  : '/templates/components/obs-pool-modal/obs-pool-modal.html',
			'controller'   : 'ObsPoolController',
			'controllerAs' : 'vm',
			'scope'        : {
				'observation'       : '=',
				'group'             : '=',
				'readOnly'          : '=',
				'activeGroup'       : '=',
				'isObsLevel'        : '=',
				'isScore'           : '=',
				'update'            : '&',
				'printObs'          : '&',
				'isTemplatePreview' : '='
			}
		};

		return directive;
	}

	angular
		.module( 'app.components' )
		.directive( 'obsPoolModal', obsPoolModal );
} )( );
